import { useContext, useEffect, useRef, useState } from 'react'
import MapContext from '../MapContext';
import './Coordinate.css';
import { Divider } from 'primereact/divider';
import { getPointResolution, toLonLat } from 'ol/proj';
import { Toast } from 'primereact/toast';
import { ScaleLine } from 'ol/control';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import GoLocation from './GoLocation/GoLocation';
import { useAppSelector } from '../../../../store/hooks';
import { useDispatch } from 'react-redux';
import { setGoLocation, setShowLoading } from '../../../../features/sharedSlice';
import { Size } from 'ol/size';
import { Dialog } from 'primereact/dialog';
import jsPDF from 'jspdf';


export default function Coordinate() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const map = useContext(MapContext)
    const toast = useRef<any>(null);

    const [coordinate, setcoordinate] = useState<any>('28.809624 , 41.069122')
    const [scale, setscale] = useState<any>('1 : 3,395,295')
    const [selectedScale, setSelectedScale] = useState(null);
    const [showScaleSelect, setShowScaleSelect] = useState(false);
    const [printPopupVisibility, setPrintPopupVisibility] = useState(false);
    const [mapCanvas, setMapCanvas] = useState<any>(undefined);
    const [size, setSize] = useState<any>(undefined);
    const [viewResolution, setViewResolution] = useState<any>(undefined);
    const [imagePreview, setImagePreview] = useState<any>(null);

    const goCoordinateState = useAppSelector(state => state.sharedState.goLocation);
    const layerNodes = useAppSelector(state => state.layer.layerNodes);
    const services = useAppSelector(state => state.layer.services);
    const legend = useAppSelector(state => state.sharedState.legend);

    const scales = [
        { name: '1 : 1,000', code: 1000 },
        { name: '1 : 5,000', code: 5000 },
        { name: '1 : 10,000', code: 10000 },
        { name: '1 : 25,000', code: 25000 },
        { name: '1 : 50,000', code: 50000 },
        { name: '1 : 100,000', code: 100000 },
        { name: '1 : 250,000', code: 250000 },
        { name: '1 : 500,000', code: 500000 },
        { name: '1 : 1,000,000', code: 1000000 },
        { name: '1 : 2,000,000', code: 2000000 },
        { name: '1 : 3,000,000', code: 3000000 }
    ];

    useEffect(() => {
        const scaleLine = new ScaleLine({
            units: 'metric',
            bar: true,
        });

        map.once('rendercomplete', (e: any) => {
            map.on('moveend', () => {
                var mapScale = '1 : ' + Math.round(scaleLine.getScaleForResolution()).toLocaleString();
                setscale(mapScale);
            });
        });

        map.addControl(scaleLine);
        map.on('pointermove', setCoordinate);

        var size = map.getSize();
        // console.log(size);

        var viewResolution = map.getView().getResolution();
        setViewResolution(viewResolution)
        setSize(size)
        return () => {
            map.un('pointermove', setCoordinate);
        };
    }, []);


    const onScaleChange = (e: any) => {
        const scaleResolution =
            e.value.code /
            getPointResolution(
                map.getView().getProjection(),
                3571.4,
                map.getView().getCenter() as any
            );
        map.getView().setResolution(scaleResolution)
        setTimeout(() => {
            setSelectedScale(e.value);
            setscale(e.value.name);
        }, 50);
    }

    const toggleGoCoordinate = () => {
        dispatch(setGoLocation(!goCoordinateState));
    };

    const exportMap = async () => {
        map.once('rendercomplete', async () => {
            setImagePreview(undefined);
            const mapCanvas = document.createElement('canvas');
            const size = map.getSize() as Size;

            mapCanvas.width = size[0];
            mapCanvas.height = size[1];
            // console.log(size);

            const mapContext = mapCanvas.getContext('2d') as CanvasRenderingContext2D;
            setMapCanvas(mapCanvas)
            map.getViewport()
                .querySelectorAll('.ol-layer canvas, canvas.ol-layer')
                .forEach((canvas: any) => {
                    if (canvas.width > 0) {
                        // console.log(canvas);

                        const opacity = canvas.parentNode.style.opacity || canvas.style.opacity;
                        mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                        let matrix;
                        const transform = canvas.style.transform;
                        if (transform) {
                            // Get the transform parameters from the style's transform matrix
                            matrix = transform
                                .match(/^matrix\(([^\(]*)\)$/)[1]
                                .split(',')
                                .map(Number);
                        } else {
                            matrix = [
                                parseFloat(canvas.style.width) / canvas.width,
                                0,
                                0,
                                parseFloat(canvas.style.height) / canvas.height,
                                0,
                                0,
                            ];
                        }
                        // Apply the transform to the export map context
                        mapContext?.setTransform(matrix);
                        // console.log(mapContext);

                        const backgroundColor = canvas.parentNode.style.backgroundColor;
                        if (backgroundColor) {
                            mapContext.fillStyle = backgroundColor;
                            mapContext.fillRect(0, 0, canvas.width, canvas.height);
                        }
                        mapContext.drawImage(canvas, 0, 0);

                    }
                });
            mapContext.globalAlpha = 1;
            mapContext.setTransform(1, 0, 0, 1, 0, 0);

            const image = (await promiseImageLoad('img/north-arrow.png')) as HTMLImageElement;

            const copyServices = [...services];
            const imageObjects: any[] = [];
            copyServices.forEach((service, index) => {
                if (index === 0) {
                    return;
                } else {
                    const visibleLayers = service.layers.filter((layer) => layer.visible);
                    for (let i = 0; i < visibleLayers.length; i++) {
                        const visibleLayerId = visibleLayers[i].id;
                        layerNodes.some((layerNode) => {
                            const foundChild = layerNode.children.find((child: any) => child.data.id === visibleLayerId);
                            if (foundChild) {
                                imageObjects.push({
                                    name: foundChild.data.alias ? foundChild.data.alias : foundChild.label,
                                    imageData: foundChild.iconData,
                                    layer_name: foundChild.data.name,
                                    icon: foundChild.icon,
                                });
                                return true;
                            } else {
                                return false;
                            }

                        });
                    }
                }
            });

            if (legend.url) {
                if (imageObjects.some((obj: any) => obj.name.includes('Parsel'))) {
                    const legendImage = (await promiseImageLoad(legend.url)) as HTMLImageElement;
                    const width = legendImage.naturalWidth;
                    const heigth = legendImage.naturalHeight;
                    mapContext.drawImage(legendImage, mapCanvas.width - 220 - width, mapCanvas.height - heigth - 10, width, heigth);
                    // mapContext.fillText(legend.text, mapCanvas.width - 170, mapCanvas.height - (16 * 30), 150);
                    mapContext.beginPath();
                    mapContext.stroke();
                    // mapContext.fillText(imageObject.name, mapCanvas.width - 170, mapCanvas.height - (16 * 30), 150);
                }

                const findedTematik = imageObjects.find((obj: any) => obj.icon === 'iconforsidebar_tematik_harita');
                if (findedTematik) {
                    const tematikUrl = `https://osb.ankageo.com/rest/v1/geoserver/osb/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&HEIGHT=10&LAYER=ibbs2_bolgelere_gore_istihdam&style=${findedTematik.layer_name}&legend_options=fontName:Times%20New%20Roman;fontAntiAliasing:true;fontColor:0xFFFFFF;fontSize:10;bgColor:0x1F2D40;dpi:180`
                    const legendImage = (await promiseImageLoadForTematik(tematikUrl)) as HTMLImageElement;
                    const width = legendImage.naturalWidth;
                    const heigth = legendImage.naturalHeight;
                    mapContext.drawImage(legendImage, 10, mapCanvas.height - heigth - 50, width, heigth);
                    // mapContext.fillText(legend.text, mapCanvas.width - 170, mapCanvas.height - (16 * 30), 150);
                    mapContext.beginPath();
                    mapContext.stroke();
                    // mapContext.fillText(imageObject.name, mapCanvas.width - 170, mapCanvas.height - (16 * 30), 150);
                }
            }

            if (imageObjects.length > 0) {
                const reversedImageObjects = imageObjects.reverse();
                for (let i = 0; i < reversedImageObjects.length; i++) {
                    const imageObject = reversedImageObjects[i];

                    const layerImage = (await promiseImageLoad(imageObject.imageData)) as HTMLImageElement;

                    mapContext.drawImage(layerImage, mapCanvas.width - 200, mapCanvas.height - (32 + i * 30), 24, 24);
                    mapContext.font = '14px Arial';
                    mapContext.fillText(imageObject.name, mapCanvas.width - 170, mapCanvas.height - (16 + i * 30), 150);
                }

                mapContext.beginPath();
                mapContext.rect(mapCanvas.width - 210, mapCanvas.height - imageObjects.length * 30 - 8, 200, imageObjects.length * 30);
                mapContext.stroke();
            }
            mapContext.beginPath();
            mapContext.rect(10, mapCanvas.height - 40, 120, 30);
            mapContext.stroke();
            mapContext.fillText(scale, 25, mapCanvas.height - 20, 120);
            mapContext.drawImage(image, mapCanvas.width - 120, 20)
            // console.log(mapCanvas);
            setTimeout(() => {
                setImagePreview(mapCanvas.toDataURL());
                dispatch(setShowLoading(false))
            }, 100)
        });
        map.renderSync();
    };

    const pngExport = () => {
        const link = document.createElement('a');
        link.download = 'print.jpeg';
        link.href = mapCanvas.toDataURL();
        link.click();
    }

    const pdfExport = () => {
        var pdf = new jsPDF('landscape', undefined, 'A4');
        pdf.addImage(
            mapCanvas.toDataURL('image/jpeg'),
            'JPEG',
            0,
            0,
            297,
            210
        );

        pdf.save('map.pdf');
        // Reset original map size
        map.setSize(size);
        map.getView().setResolution(viewResolution);

        var width = Math.round((297 * 150) / 25.4);
        var height = Math.round((210 * 150) / 25.4);
        // console.log(width);
        // console.log(height);

        // Set print size
        var printSize = [width, height];
        map.setSize(printSize);
        var scaling = Math.min(width / size[0], height / size[1]);
        map.getView().setResolution(viewResolution / scaling);
    }
    // const onClickCoordinate = () => {
    //     navigator.clipboard.writeText(coordinate);
    //     toast.current.show({ severity: 'success', detail: 'Koordinat Kopyalandı.', life: 3000 });
    // }

    const promiseImageLoad = (imageData: any) => {
        return new Promise((resolve, reject) => {
            const image = new Image();

            image.src = imageData;
            image.crossOrigin = "anonymous"
            image.onload = () => {
                resolve(image);
            };
            image.onerror = () => {
                reject();
            };
        });
    };
    const promiseImageLoadForTematik = (imageData: any) => {
        return new Promise((resolve, reject) => {
            const image = new Image();

            image.src = imageData;
            image.crossOrigin = "anonymous"
            image.onload = () => {
                resolve(image);
            };
            image.onerror = () => {
                reject();
            };
        });
    };

    const setCoordinate = (e: any) => {
        const translated = toLonLat(e.coordinate)
        const coordinate = [translated[0].toFixed(6), translated[1].toFixed(6)];
        setcoordinate(coordinate.join(','))
    }

    useEffect(() => {
        if (printPopupVisibility) {
            dispatch(setShowLoading(true))
            exportMap();
        }
    }, [printPopupVisibility, legend.url])

    return (
        <>
            <div className='coordinate-container'>
                <Button className='p-button-rounded coordinate-button' tooltip={t('COORDINATE COMP.Print')} tooltipOptions={{ position: 'top' }} icon="pi pi-print" onClick={() => setPrintPopupVisibility(true)}></Button>
                {printPopupVisibility && imagePreview && <Dialog header='Yazdır' visible={true} onHide={() => setPrintPopupVisibility(false)}>
                    <img src={imagePreview} alt="" width={800} />
                    <div style={{ padding: '1em', display: 'flex', justifyContent: 'center' }}>
                        <Button label={t('BUTTON.Export PDF')} style={{ marginRight: '1em' }} onClick={() => pdfExport()} />
                        <Button label={t('BUTTON.Export JPEG')} onClick={() => pngExport()} />
                    </div>
                </Dialog>}
                <Button className='p-button-rounded coordinate-button' tooltip={t('COORDINATE COMP.Location')} tooltipOptions={{ position: 'top' }} icon="pi pi-map-marker" onClick={() => toggleGoCoordinate()}></Button>
                <div style={{ height: '30px' }}>
                    <Divider type='dashed' layout="vertical" align='center'></Divider>
                </div>
                <div className='epsg'>EPSG:4326</div>
                <div style={{ height: '30px' }}>
                    <Divider type='dashed' layout="vertical" align='center'></Divider>
                </div>
                <div className='coordinate'>{coordinate}</div>
                <div style={{ height: '30px' }}>
                    <Divider type='dashed' layout="vertical" align='center'></Divider>
                </div>
                <div className='scale' onClick={() => { setShowScaleSelect(!showScaleSelect) }}>{scale}</div>
                {showScaleSelect &&
                    <Dropdown className="scale-select" value={selectedScale} options={scales} onChange={onScaleChange} optionLabel="name" placeholder="Ölçek Seçiniz" />
                }
            </div>
            {
                goCoordinateState &&
                <GoLocation></GoLocation>
            }
            <Toast ref={toast} />
        </>
    )
}
